//没有请为空
// let cdn = 'https://pcdn.youjiate.club/oem/yjt';
let cdn = '/static/oem/org';
let host = '/static/oem/org';


const config = {
  //平台名称
  platformName: '展通安全教育网络学院（机构版）',
  entName:"展通安全教育网络学院（机构版）",
  suffixName:'',
  //平台code (可为空，用于贴牌标记贴牌端注册的企业信息)
  platformCode: '',
  //个人端应用名称（或小程序名称）
  userAppName: '-',
  //企业端应用名称（或小程序名称）
  entAppName: '在线安全生产学习平台',
  //底部版权信息 支持html
  copyright: '备案号:湘ICP备18004301号 经营执照 最佳显示分辨率：1920*1080',
  //二维码host路径
  qRCodeHost: 'https://fueledu.hnztaqkj.com/qrcode/index',
  //是否开启商城
  includeMall: false,
  enableEntRegister: false,
  enableActivation: false,
  enableQRCodeRegistration: false,
  //是否免费课程
  freeCourse: false,
  enableRegistration:false,
  specialPlane:"400-8919-218",
  phone: "191-1883-8235",
  //显示logo
  isLogo:false,
  isUse:false,
  isDisplayTitle:false,

  //图片节点，规范请统一放入到项目的 static/img 下 命名请规范
  images: {
    //logo图
    logoImage: cdn + '/img/logo.png',
    //登陆页面图
    loginTopImage: cdn + '/img/login-top-image.png',
    //用户小程序码图片
    userXcxCodeImage: cdn + '/img/userXcxCodeImage.png',
    //个人端简单版本二维码（正方形）
    userXcxCodeSimpleImage:  cdn + '/img/userXcxCodeSimpleImage.png',
    //企业端小程序二维码图片
    enterpriseXcxCodeImage: cdn+'/img/enterpriseXcxCodeImage.jpg',
    //企业端简单版本二维码
    enterpriseXcxCodeSimpleImage: cdn+'/img/enterpriseXcxCodeSimpleImage.png',
    //注册-个人用户注册二维码
    registerUserQRCodeImage: cdn + '/img/registerUserQRCode.jpg',
    navTopLogo: cdn + '/img/zt-nav-top-logo2.jpg',
    //客服微信
    kfWeChat: cdn + '/img/kfWeChat.png',
  },
  files: {
    protocol: {
      //企业激活相关协议
      entActivation: [
        {
          name: '《专项保密协议书》',
          url: host + '/files/protocol/entActivation/zxbmxy.html'
        }
      ],
      userRegister: [
        {
          name: '《用户注册协议》',
          url: host + '/files/protocol/register/register.html'
        }
      ]
    }
  }
}
export default config




// WEBPACK FOOTER //
// ./src/config/oem/config_default.js